import oAxiosInstance from "config/Axios";

export const apiCallGetAllChecks = oData => {
  return oAxiosInstance.post("cheques/consultar", oData);
};

export const apiCallChecksDelete = nId => {
  return oAxiosInstance.delete(`cheques/${nId}`);
};

export const apiCallGetBanks = () => {
  return oAxiosInstance.get("bancos");
};

export const apiCallChecksSave = oData => {
  return oAxiosInstance.post("cheques", oData);
};

export const apiCallChecksUpdate = (nId, oData) => {
  return oAxiosInstance.put(`cheques/${nId}`, oData);
};
